import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import {
  DownloadAppModalComponent,
  RouterService,
  ShareModalService,
  UserModel,
  UserService,
} from '@lib/gc-common';

@Component({
  selector: 'mip-profile-public-actions',
  templateUrl: './profile-public-actions.component.html',
  styleUrls: ['./profile-public-actions.component.scss'],
})
export class ProfilePublicActionsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() profile: UserModel = null;

  isAuthenticated = false;

  userNetworks = [];
  networksBaseUrl = {
    instagram: {
      text: 'Instagram',
      icon: 'instagram',
      baseUrl: `https://instagram.com/`,
    },
    facebook: {
      text: 'Facebook',
      icon: 'facebook',
      baseUrl: `https://facebook.com/`,
    },
    youtube: {
      text: 'Youtube',
      icon: 'youtube',
      baseUrl: `https://youtube.com/`,
    },
    tiktok: {
      text: 'TikTok',
      icon: 'tiktok',
      baseUrl: `https://tiktok.com/@`,
    },
    twitter: {
      text: 'Twitter',
      icon: 'twitter',
      baseUrl: `https://twitter.com/`,
    },
  };

  onUserAuthenticationSubscription = null;

  constructor(
    private bottomSheet: MatBottomSheet,
    private userService: UserService,
    private routeService: RouterService,
    private shareModalService: ShareModalService,
  ) {
    this.onUserAuthenticationSubscription = this.userService.onUserAuthentication().subscribe((user) => {
      this.isAuthenticated = this.userService.isAuthenticated();
      // console.log('profile-public-actions.component->constructor(): this.isAuthenticated', this.isAuthenticated, user);
    });
  }

  async ngOnInit() {}

  ngOnDestroy() {
    if (this.onUserAuthenticationSubscription) {
      this.onUserAuthenticationSubscription.unsubscribe();
    }
  }

  ngOnChanges() {
    // console.log('profile-public-actions.component->ngOnChanges(): this.profile', this.profile);

    const userNetworks = this.profile.getNetworks();
    // console.log('profile-public-actions.component->ngOnChanges(): userNetworks', userNetworks);

    this.userNetworks = [];

    if (userNetworks) {
      for (const i in this.networksBaseUrl) {
        if (i in userNetworks) {
          // console.log('profile-public-actions.component->ngOnChanges(): this.networksBaseUrl', i, this.networksBaseUrl[i]);
          this.userNetworks.push({
            text: this.networksBaseUrl[i].text,
            icon: this.networksBaseUrl[i].icon,
            href: `${this.networksBaseUrl[i].baseUrl}${userNetworks[i]}`,
          });
        }
      }
      // console.log('profile-public-actions.component->ngOnChanges(): this.userNetworks', this.userNetworks);
    }
  }

  openDownloadAppDialog() {
    this.bottomSheet.open(DownloadAppModalComponent);
  }

  shareProfile() {
    this.shareModalService.shareOpen({
      url: window.location.pathname + window.location.search,
      imageLeft: this.profile.getAvatarSource(),
    });
  }
}
